"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _lib = require("@cimpress/react-components/lib");

var _reactComponents = require("@cimpress/react-components");

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var EditSavedSearch = function EditSavedSearch(_ref) {
  var _savedSearches$filter;

  var label = _ref.label,
      _ref$savedSearches = _ref.savedSearches,
      savedSearches = _ref$savedSearches === void 0 ? [] : _ref$savedSearches,
      onDelete = _ref.onDelete,
      onDefault = _ref.onDefault,
      showModal = _ref.showModal,
      closeModal = _ref.closeModal;
  var initialSelected = savedSearches === null || savedSearches === void 0 ? void 0 : (_savedSearches$filter = savedSearches.filter(function (filter) {
    return filter.isDefault;
  })[0]) === null || _savedSearches$filter === void 0 ? void 0 : _savedSearches$filter.label;

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      selectedValue = _useState2[0],
      setSelectedValue = _useState2[1];

  (0, _react.useEffect)(function () {
    if (initialSelected) setSelectedValue(initialSelected);
  }, [initialSelected]);
  var Robot = _reactComponents.shapes.Robot;

  var noSavedSearch = /*#__PURE__*/_react["default"].createElement(Robot, {
    status: "warning"
  });

  var savedSearchOptions = savedSearches.map(function (_ref2) {
    var label = _ref2.label;
    return /*#__PURE__*/_react["default"].createElement(_reactComponents.Radio, {
      label: label,
      value: label,
      key: "radio-".concat(label)
    });
  });
  return /*#__PURE__*/_react["default"].createElement(_lib.Modal, {
    show: showModal,
    onRequestHide: function onRequestHide() {
      setSelectedValue(initialSelected);
      closeModal();
    },
    title: label,
    closeButton: true,
    footer: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_lib.Button, {
      variant: "default",
      onClick: function onClick() {
        return onDelete(selectedValue);
      }
    }, "Delete"), /*#__PURE__*/_react["default"].createElement(_lib.Button, {
      variant: "primary",
      onClick: function onClick() {
        return onDefault(selectedValue);
      }
    }, "Mark as default"))
  }, /*#__PURE__*/_react["default"].createElement(_reactComponents.RadioGroup, {
    onChange: function onChange(e, value) {
      return setSelectedValue(value);
    },
    valueSelected: selectedValue,
    defaultSelected: selectedValue,
    name: "radioGrp"
  }, savedSearchOptions.length ? savedSearchOptions : noSavedSearch));
};

var _default = EditSavedSearch;
exports["default"] = _default;